import React, { createContext, useContext, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api, setAuthToken } from "@/lib/api";

const AuthContext = createContext(null);

function getDeviceId() {
  try {
    let d = localStorage.getItem("lci_device");
    if (!d) {
      d = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
      localStorage.setItem("lci_device", d);
    }
    return d;
  } catch { return "web"; }
}

export function AuthProvider({ children }) {
  const queryClient = useQueryClient();
  const [user, setUser] = useState(null);      // null=checking, false=anon, obj=auth
  const [token, setToken] = useState(() => localStorage.getItem("lci_token") || null);

  useEffect(() => {
    if (!token) { setUser(false); return; }
    setAuthToken(token);
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("lci_token"); setToken(null); setUser(false); });
  }, [token]);

  const persist = (data) => {
    queryClient.clear();
    localStorage.setItem("lci_token", data.token);
    setAuthToken(data.token);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => persist((await api.post("/auth/login", { email, password, device_id: getDeviceId() })).data);
  const register = async (nombre, email, password) => persist((await api.post("/auth/register", { nombre, email, password })).data);
  const logout = () => {
    queryClient.clear();
    localStorage.removeItem("lci_token");
    setAuthToken(null);
    setToken(null);
    setUser(false);
  };
  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refreshUser, setSession: persist }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
